import React from 'react';
import PropTypes from 'prop-types';

import './TemplateCenter.scss';

import commonConstant from '../../../common/_commonConstant';
import { Footer } from '../../../components';

const TemplateCenter = props => (
  <div className="TemplateCenter">
    <div className="white-box">
      <div className="body">
        <div className="box-logo">
          <img className="logo" src={commonConstant.ezyParkLogo} alt="" />
          <span className="text">
            <div className="title">EZY PARKING</div>
            <div className="description">SMART PAYMENT SOLUTION</div>
          </span>
        </div>
        <div className="line" />
        {props.children}
      </div>
      <div className="canvas-green">
        <span className="white-triangle" />
      </div>
      <Footer />
    </div>
  </div>
);

TemplateCenter.propTypes = {
  'children': PropTypes.any.isRequired,
};

export default TemplateCenter;
